import syncStore from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-employer/actions/syncStore';

export default () => ({
    state  : { trackedErrors: []},
    actions: { syncStore },
});